ApiPromise = require 'network/api-promise'
Alerts = require 'views/lib/alerts'
Auth = require 'db/auth'
Controller = require 'controller'
MemberFeatures = require 'data/member-features'
ModelLoader = require 'db/model-loader'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
earnedTemplate = require 'views/templates/member_gold_earned'
l = require 'lib/localize'
localizeCount = require 'lib/localize-count'

module.exports = class MemberGoldView extends View
  initialize: ->
    @makeDebouncedMethods 'render'

    @listenTo @model, 'change:oneTimeMessagesDismissed', @renderDebounced
    @listenTo @model, 'change:paidAccount', @renderDebounced

  events:
    'click .js-close-modal': 'closeGoldEarned'
    'click .js-start-using-gold': 'startUsingGold'

  render: ->
    @$el.empty()

    if !Auth.isMe(@model)
      return @

    if ((!@model.isDismissed("GoldEarned") || !@options.allowDismiss)) && !@activating
      credits = @model.get('credits')
      nonZeroCredits =
        _.filter credits, (c) ->
          !c.applied && c.count > 0 && c.type in ['invitation', 'promoCode']

      creditMonths = _.reduce(nonZeroCredits, ((memo, credit) -> memo + credit.count), 0)

      if creditMonths
        if creditMonths > 12
          creditMonths = 12

        fullNames = _.chain(nonZeroCredits)
          .filter((c) -> c.type == 'invitation' && c.memberInvited?)
          .pluck('memberInvited')
          .pluck('fullName')
          .value()

        earnedData =
          hasInvitations: fullNames.length > 0
          joinedNames: fullNames
          localizedCongratulations: localizeCount('months of trello gold', creditMonths)
          showClose: @options.allowDismiss
          hasGold: @model.isGold()

        @$el.html(earnedTemplate(earnedData))

    @

  refreshPaidAccount: ->
    if !@startedPolling?
      @startedPolling = Date.now()

    if @startedPolling + Util.getMs(minutes: 1) < Date.now()
      Alerts.hide('activating')
      Alerts.show('activating gold timeout', 'error', 'activating-failed')
      return

    ApiPromise url: "#{@model.urlRoot}/#{@model.id}"
    .then (member) =>
      # keep reloading the account until it is done processing
      if MemberFeatures.productShortNames.trelloGoldMonthly in member.products
        delete @startedPolling
        Alerts.hide('activating')
        Controller.navigate '/', { trigger: true }
      else
        @setTimeout(_.bind(@refreshPaidAccount, @), Util.getMs({ seconds: 1 }))
      return
    .done()

  startUsingGold: (e) ->
    Util.stop(e)
    @activating = true
    Alerts.show('activating gold', 'info', 'activating')
    @render() # no data has actually changed yet, but we want to hide the modal

    ApiPromise
      method: 'post'
      url: "#{@model.urlRoot}/#{@model.id}/unpaidAccount"
      data:
        products: [MemberFeatures.productShortNames.trelloGoldMonthly]
    .then =>
      @refreshPaidAccount()

  closeGoldEarned: (e) ->
    Util.stop(e)
    @model.dismiss('GoldEarned')



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-gold-view.coffee